import { Injectable } from '@angular/core';
import {EndpointService} from '../endpoints.service';
import {StorageService} from '../../@core/services/storage.service';
import {
  _AQH_EVE_1, _AQH_EVE_10, _AQH_EVE_12, _AQH_EVE_13, _AQH_EVE_14, _AQH_EVE_16, _AQH_EVE_17, _AQH_EVE_18, _AQH_EVE_19,
  _AQH_EVE_2, _AQH_EVE_21, _AQH_EVE_22, _AQH_EVE_24, _AQH_EVE_25, _AQH_EVE_26, _AQH_EVE_27,
  _AQH_EVE_3, _AQH_EVE_34, _AQH_EVE_35, _AQH_EVE_5, _AQH_EVE_7, _AQH_EVE_8, _AQH_EVE_9,
  _AQH_EVE_41, _AQH_EVE_42, _AQH_EVE_43, _AQH_EVE_45, _AQH_EVE_46, _AQH_EVE_47, _AQH_EVE_48, _AQH_EVE_49, _AQH_EVE_50, _AQH_EVE_51, _AQH_EVE_55,
  _AQH_EVE_60, _AQH_EVE_61, _AQH_EVE_62, _AQH_EVE_63, _AQH_EVE_64,
  _AQH_EVE_73, _AQH_EVE_74, _AQH_EVE_75,
  _AQH_EVE_90, _AQH_EVE_91, _AQH_EVE_92,
  _AQH_EVE_162,
  _AQH_EVE_171, _AQH_EVE_172, _AQH_EVE_173, _AQH_EVE_174,
  AQH_EVE_0,
  AQH_EVE_1, AQH_EVE_10, AQH_EVE_11, AQH_EVE_12, AQH_EVE_13, AQH_EVE_14, AQH_EVE_15, AQH_EVE_16, AQH_EVE_17, AQH_EVE_18, AQH_EVE_19,
  AQH_EVE_2, AQH_EVE_20, AQH_EVE_21, AQH_EVE_22, AQH_EVE_23, AQH_EVE_24, AQH_EVE_25, AQH_EVE_26, AQH_EVE_27, AQH_EVE_28, AQH_EVE_29, AQH_EVE_30, AQH_EVE_31, AQH_EVE_32, AQH_EVE_33, AQH_EVE_34, AQH_EVE_35, AQH_EVE_36, AQH_EVE_37,
  AQH_EVE_3,
  AQH_EVE_4, AQH_EVE_5, AQH_EVE_6, AQH_EVE_7, AQH_EVE_8, AQH_EVE_9,
  AQH_EVE_40, AQH_EVE_41, AQH_EVE_42, AQH_EVE_43, AQH_EVE_44, AQH_EVE_45, AQH_EVE_46, AQH_EVE_47, AQH_EVE_48, AQH_EVE_49, AQH_EVE_50, AQH_EVE_51, AQH_EVE_52, AQH_EVE_53, AQH_EVE_55,
  AQH_EVE_60, AQH_EVE_61, AQH_EVE_62, AQH_EVE_63, AQH_EVE_64, AQH_EVE_65, AQH_EVE_67,
  AQH_EVE_73, AQH_EVE_74, AQH_EVE_75, AQH_EVE_76,
  AQH_EVE_78, AQH_EVE_79,
  AQH_EVE_90, AQH_EVE_91, AQH_EVE_92, AQH_EVE_93, AQH_EVE_94,
  AQH_EVE_100, AQH_EVE_101, AQH_EVE_102, AQH_EVE_103, AQH_EVE_104, AQH_EVE_105, AQH_EVE_106, AQH_EVE_107, AQH_EVE_108, AQH_EVE_109,
  AQH_EVE_110, AQH_EVE_111, AQH_EVE_112, AQH_EVE_113, AQH_EVE_114, AQH_EVE_115,
  _AQH_EVE_110, _AQH_EVE_111, _AQH_EVE_112, _AQH_EVE_113, _AQH_EVE_114,
  AQH_EVE_160, AQH_EVE_161, AQH_EVE_162,
  AQH_EVE_170, AQH_EVE_171, AQH_EVE_172, AQH_EVE_173, AQH_EVE_174,
  AQH_EVE_180, AQH_EVE_181, AQH_EVE_182, AQH_EVE_183, AQH_EVE_185
} from '../models/input.module';
import { CoOrganiserAccessLevel } from '../models/response.module';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  constructor(private endpointService: EndpointService,
              private storageService: StorageService) {
  }

  getEvents(params: AQH_EVE_0) {
    return this.endpointService.aqh_eve_0(params).pipe(map((data => {
      return data;
    })))
  }

  addEvent(params: _AQH_EVE_1, companyId?: string) {
    let payload: AQH_EVE_1 = {
      company_id: companyId ?? this.storageService.getSelectedCompanyId(),
      ...params,
    }
    console.log('addEvent - companyId param:', companyId, '| storage:', this.storageService.getSelectedCompanyId(), '| payload.company_id:', payload.company_id);
    return this.endpointService.aqh_eve_1(payload).pipe(map((data => {
      return data;
    })))
  }

  editEvent(params: _AQH_EVE_2, companyId?: string) {
    let payload: AQH_EVE_2 = {
      company_id: companyId ?? this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_2(payload).pipe(map((data => {
      return data;
    })));
  }

  deleteEvent(params: _AQH_EVE_3, companyId?: string) {
    let payload: AQH_EVE_3 = {
      company_id: companyId ?? this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_3(payload).pipe(map((data => {
      return data;
    })));
  }

  getEventTypes(params: AQH_EVE_4) {
    return this.endpointService.aqh_eve_4(params).pipe(map((data => {
      return data.data;
    })));
  }

  // ==================== PUBLIC METHODS (No Auth Required) ====================

  getPublicEvents(params: AQH_EVE_0) {
    return this.endpointService.aqh_eve_81(params).pipe(map((data => {
      return data;
    })));
  }

  /**
   * Get public events in compact mode (~70% smaller payload).
   * Use for list views, map markers, search results.
   */
  getPublicEventsCompact(params: Omit<AQH_EVE_0, 'compact'>) {
    return this.endpointService.aqh_eve_81({ ...params, compact: true }).pipe(map((data => {
      return data;
    })));
  }

  getPublicEvent(event_id: number) {
    return this.endpointService.aqh_eve_82(event_id).pipe(map((data => {
      return data;
    })));
  }

  getPublicEventTypes() {
    return this.endpointService.aqh_eve_83().pipe(map((data => {
      return data.data;
    })));
  }

  getPublicEventClasses(event_id: number) {
    return this.endpointService.aqh_eve_84(event_id).pipe(map((data => {
      return data.data;
    })));
  }

  getPublicEventServices(event_id: number) {
    return this.endpointService.aqh_eve_85(event_id).pipe(map((data => {
      return data.data;
    })));
  }

  getPublicEventSponsors(event_id: number) {
    return this.endpointService.aqh_eve_86(event_id).pipe(map((data => {
      return data.data;
    })));
  }

  getPublicEventContacts(event_id: number) {
    return this.endpointService.aqh_eve_87(event_id).pipe(map((data => {
      return data.data;
    })));
  }

  editEventFiles(params: _AQH_EVE_5) {
    let payload: AQH_EVE_5 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_5(payload).pipe(map((data => {
      return data;
    })));
  }

  getEventClasses(params: AQH_EVE_6) {
    return this.endpointService.aqh_eve_6(params).pipe(map((data => {
      return data.data;
    })));
  }

  addEventClass(params: _AQH_EVE_7) {
    let payload: AQH_EVE_7 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_7(payload).pipe(map((data => {
      return data;
    })));
  }

  editEventClass(params: _AQH_EVE_8) {
    let payload: AQH_EVE_8 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_8(payload).pipe(map((data => {
      return data;
    })));
  }

  deleteEventClass(params: _AQH_EVE_9) {
    let payload: AQH_EVE_9 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_9(payload).pipe(map((data => {
      return data;
    })));
  }

  editEventClassStatus(params: _AQH_EVE_10) {
    let payload: AQH_EVE_10 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_10(payload).pipe(map((data => {
      return data.data;
    })));
  }

  getEventServices(params: AQH_EVE_11) {
    return this.endpointService.aqh_eve_11(params).pipe(map((data => {
      return data.data;
    })));
  }

  addEventService(params: _AQH_EVE_12) {
    let payload: AQH_EVE_12 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_12(payload).pipe(map((data => {
      return data;
    })));
  }

  editEventService(params: _AQH_EVE_13) {
    let payload: AQH_EVE_13 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_13(payload).pipe(map((data => {
      return data;
    })));
  }

  deleteEventService(params: _AQH_EVE_14) {
    let payload: AQH_EVE_14 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_14(payload).pipe(map((data => {
      return data;
    })));
  }

  createSponsor(params: AQH_EVE_15) {
    return this.endpointService.aqh_eve_15(params).pipe(map((data => {
      return data;
    })));
  }

  addSponsorToEvent(params: _AQH_EVE_16) {
    let payload: AQH_EVE_16 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_16(payload).pipe(map((data => {
      return data;
    })));
  }

  addSponsorToEventClass(params: _AQH_EVE_17) {
    let payload: AQH_EVE_17 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_17(payload).pipe(map((data => {
      return data;
    })));
  }

  removeSponsorFromEvent(params: _AQH_EVE_18) {
    let payload: AQH_EVE_18 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_18(payload).pipe(map((data => {
      return data;
    })));
  }

  removeSponsorFromEventClass(params: _AQH_EVE_19) {
    let payload: AQH_EVE_19 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_19(payload).pipe(map((data => {
      return data;
    })));
  }

  uploadSponsorImage(params: AQH_EVE_20) {
    return this.endpointService.aqh_eve_20(params).pipe(map((data => {
      return data;
    })));
  }

  updateSponsor(params: AQH_EVE_23) {
    return this.endpointService.aqh_eve_23(params).pipe(map((data => {
      return data;
    })));
  }

  getEventSponsors(params: _AQH_EVE_21, companyId?: string) {
    const resolvedCompanyId = companyId ?? this.storageService.getSelectedCompanyId(true);
    let payload: AQH_EVE_21 = {
      ...params,
      ...(resolvedCompanyId ? { company_id: resolvedCompanyId } : {})
    } as AQH_EVE_21;
    return this.endpointService.aqh_eve_21(payload).pipe(map((data => {
      return data.data;
    })));
  }

  getEventClassSponsors(params: _AQH_EVE_22, companyId?: string) {
    const resolvedCompanyId = companyId ?? this.storageService.getSelectedCompanyId(true);
    let payload: AQH_EVE_22 = {
      ...params,
      ...(resolvedCompanyId ? { company_id: resolvedCompanyId } : {})
    } as AQH_EVE_22;
    return this.endpointService.aqh_eve_22(payload).pipe(map((data => {
      return data.data;
    })));
  }

  getEventContacts(params: _AQH_EVE_24, companyId?: string) {
    const resolvedCompanyId = companyId ?? this.storageService.getSelectedCompanyId(true);
    let payload: AQH_EVE_24 = {
      ...params,
      ...(resolvedCompanyId ? { company_id: resolvedCompanyId } : {})
    } as AQH_EVE_24;
    return this.endpointService.aqh_eve_24(payload).pipe(map((data => {
      return data.data;
    })));
  }

  addEventContact(params: _AQH_EVE_25) {
    let payload: AQH_EVE_25 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_25(payload).pipe(map((data => {
      return data;
    })));
  }

  editEventContact(params: _AQH_EVE_26) {
    let payload: AQH_EVE_26 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_26(payload).pipe(map((data => {
      return data;
    })));
  }

  deleteEventContact(params: _AQH_EVE_27) {
    let payload: AQH_EVE_27 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_27(payload).pipe(map((data => {
      return data;
    })));
  }

  getEventContactRoles(params: AQH_EVE_28) {
    return this.endpointService.aqh_eve_28(params).pipe(map((data => {
      return data.data;
    })));
  }

  registerForEventClass(params: AQH_EVE_29) {
    return this.endpointService.aqh_eve_29(params).pipe(map((data => {
      return data.data;
    })));
  }

  registerForEventService(params: AQH_EVE_30) {
    return this.endpointService.aqh_eve_30(params).pipe(map((data => {
      return data.data;
    })));
  }

  getUserEventRegistrations(params: AQH_EVE_31) {
    return this.endpointService.aqh_eve_31(params).pipe(map((data => {
      return data.data;
    })));
  }

  cancelEventClassRegistration(params: AQH_EVE_32) {
    return this.endpointService.aqh_eve_32(params).pipe(map((data => {
      return data;
    })));
  }

  cancelEventServiceRegistration(params: AQH_EVE_33) {
    return this.endpointService.aqh_eve_33(params).pipe(map((data => {
      return data;
    })));
  }

  updateEventClassRegistration(params: _AQH_EVE_34) {
    let payload: AQH_EVE_34 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_34(payload).pipe(map((data => {
      return data;
    })));
  }

  updateEventServiceRegistration(params: _AQH_EVE_35) {
    let payload: AQH_EVE_35 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_35(payload).pipe(map((data => {
      return data;
    })));
  }

  // Admin registration creation methods
  createClassRegistration(params: Omit<AQH_EVE_36, 'company_id'>) {
    let payload: AQH_EVE_36 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_36(payload).pipe(map((data => {
      return data;
    })));
  }

  createServiceRegistration(params: Omit<AQH_EVE_37, 'company_id'>) {
    let payload: AQH_EVE_37 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_37(payload).pipe(map((data => {
      return data;
    })));
  }

  // Schedule methods
  getSchedule(params: AQH_EVE_40) {
    return this.endpointService.aqh_eve_40(params).pipe(map((data => {
      return data.data;
    })));
  }

  createSchedule(params: _AQH_EVE_41) {
    let payload: AQH_EVE_41 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_41(payload).pipe(map((data => {
      return data.data;
    })));
  }

  updateSchedule(params: _AQH_EVE_42) {
    let payload: AQH_EVE_42 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_42(payload).pipe(map((data => {
      return data.data;
    })));
  }

  deleteSchedule(params: _AQH_EVE_43) {
    let payload: AQH_EVE_43 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_43(payload).pipe(map((data => {
      return data;
    })));
  }

  getScheduleEntries(params: AQH_EVE_44) {
    return this.endpointService.aqh_eve_44(params).pipe(map((data => {
      return data.data;
    })));
  }

  reorderScheduleEntries(params: _AQH_EVE_45) {
    let payload: AQH_EVE_45 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_45(payload).pipe(map((data => {
      return data.data;
    })));
  }

  addScheduleEntry(params: _AQH_EVE_46) {
    let payload: AQH_EVE_46 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_46(payload).pipe(map((data => {
      return data.data;
    })));
  }

  updateScheduleEntry(params: _AQH_EVE_47) {
    let payload: AQH_EVE_47 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_47(payload).pipe(map((data => {
      return data.data;
    })));
  }

  deleteScheduleEntry(params: _AQH_EVE_48) {
    let payload: AQH_EVE_48 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_48(payload).pipe(map((data => {
      return data;
    })));
  }

  batchUpdateScheduleEntries(params: _AQH_EVE_55) {
    let payload: AQH_EVE_55 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_55(payload).pipe(map((data => {
      return data.data;
    })));
  }

  startLiveSchedule(params: _AQH_EVE_49) {
    let payload: AQH_EVE_49 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_49(payload).pipe(map((data => {
      return data.data;
    })));
  }

  advanceSchedule(params: _AQH_EVE_50) {
    let payload: AQH_EVE_50 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_50(payload).pipe(map((data => {
      return data.data;
    })));
  }

  previousScheduleEntry(params: _AQH_EVE_51) {
    let payload: AQH_EVE_51 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_51(payload).pipe(map((data => {
      return data.data;
    })));
  }

  getLiveStatus(params: AQH_EVE_52) {
    return this.endpointService.aqh_eve_52(params).pipe(map((data => {
      return data.data;
    })));
  }

  // Scratch current entry and advance to next
  scratchCurrentEntry(schedule_id: number, entry_id: number) {
    // Mark entry as scratched
    let payload: AQH_EVE_47 = {
      company_id: this.storageService.getSelectedCompanyId(),
      entry_id,
      status: 'scratched'
    };
    return this.endpointService.aqh_eve_47(payload).pipe(map((data => {
      return data.data;
    })));
  }

  // End live session - mark schedule as completed
  endLiveSession(schedule_id: number) {
    let payload: AQH_EVE_42 = {
      company_id: this.storageService.getSelectedCompanyId(),
      schedule_id,
      status: 'completed'
    };
    return this.endpointService.aqh_eve_42(payload).pipe(map((data => {
      return data.data;
    })));
  }

  getPublicSchedules(params: AQH_EVE_53) {
    return this.endpointService.aqh_eve_53(params).pipe(map((data => {
      return data.data;
    })));
  }

  // Announcement methods
  getAnnouncements(params: AQH_EVE_65) {
    return this.endpointService.aqh_eve_65(params).pipe(map((data => {
      return data.data;
    })));
  }

  getPublicAnnouncements(params: AQH_EVE_65) {
    return this.endpointService.aqh_eve_66(params).pipe(map((data => {
      return data.data;
    })));
  }

  // Results methods
  getPublicResults(eventId: number) {
    return this.endpointService.aqh_eve_140({ event_id: eventId }).pipe(map((data => {
      return data.data;
    })));
  }

  getUserResults(userId: string) {
    return this.endpointService.aqh_eve_141({ user_id: userId }).pipe(map((data => {
      return data.data;
    })));
  }

  createAnnouncement(params: _AQH_EVE_60) {
    let payload: AQH_EVE_60 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_60(payload).pipe(map((data => {
      return data.data;
    })));
  }

  updateAnnouncement(params: _AQH_EVE_61) {
    let payload: AQH_EVE_61 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_61(payload).pipe(map((data => {
      return data.data;
    })));
  }

  deleteAnnouncement(params: _AQH_EVE_62) {
    let payload: AQH_EVE_62 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_62(payload).pipe(map((data => {
      return data;
    })));
  }

  uploadAnnouncementImage(params: _AQH_EVE_63) {
    let payload: AQH_EVE_63 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_63(payload).pipe(map((data => {
      return data.data;
    })));
  }

  deleteAnnouncementImage(params: _AQH_EVE_64) {
    let payload: AQH_EVE_64 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_64(payload).pipe(map((data => {
      return data;
    })));
  }

  searchUsers(search: string) {
    let payload: AQH_EVE_67 = { search };
    return this.endpointService.aqh_eve_67(payload).pipe(map((data => {
      return data.data;
    })));
  }

  // Event Tracks
  getEventTracks(event_id: number) {
    return this.endpointService.aqh_eve_68(event_id).pipe(map((data => {
      return data.data;
    })));
  }

  createEventTrack(event_id: number, track_name: string, track_description?: string) {
    return this.endpointService.aqh_eve_69(event_id, { track_name, track_description }).pipe(map((data => {
      return data.data;
    })));
  }

  updateEventTrack(track_id: number, track_name?: string, track_description?: string) {
    return this.endpointService.aqh_eve_70({ track_id, track_name, track_description }).pipe(map((data => {
      return data.data;
    })));
  }

  deleteEventTrack(track_id: number) {
    return this.endpointService.aqh_eve_71(track_id).pipe(map((data => {
      return data;
    })));
  }

  // Event Publish
  publishEvent(event_id: number, companyId?: string) {
    return this.endpointService.aqh_eve_72(event_id, {
      company_id: companyId ?? this.storageService.getSelectedCompanyId(),
      status: 'published'
    }).pipe(map((data => {
      return data.data;
    })));
  }

  unpublishEvent(event_id: number) {
    return this.endpointService.aqh_eve_72(event_id, {
      company_id: this.storageService.getSelectedCompanyId(),
      status: 'draft'
    }).pipe(map((data => {
      return data.data;
    })));
  }

  // Schedule Groups
  getScheduleGroups(schedule_id: number) {
    let payload: AQH_EVE_76 = {
      company_id: this.storageService.getSelectedCompanyId(),
      schedule_id
    };
    return this.endpointService.aqh_eve_76(payload).pipe(map((data => {
      return data.data;
    })));
  }

  createScheduleGroup(params: _AQH_EVE_73) {
    let payload: AQH_EVE_73 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    };
    return this.endpointService.aqh_eve_73(payload).pipe(map((data => {
      return data.data;
    })));
  }

  updateScheduleGroup(params: _AQH_EVE_74) {
    let payload: AQH_EVE_74 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    };
    return this.endpointService.aqh_eve_74(payload).pipe(map((data => {
      return data.data;
    })));
  }

  deleteScheduleGroup(params: _AQH_EVE_75) {
    let payload: AQH_EVE_75 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    };
    return this.endpointService.aqh_eve_75(payload).pipe(map((data => {
      return data;
    })));
  }

  // Day Breaks
  getDayBreaks(event_id: number, break_date?: string) {
    return this.endpointService.aqh_eve_77(event_id, { break_date }).pipe(map((data => {
      return data.data;
    })));
  }

  createDayBreak(event_id: number, params: Omit<AQH_EVE_78, 'event_id'>) {
    return this.endpointService.aqh_eve_78(event_id, params).pipe(map((data => {
      return data.data;
    })));
  }

  updateDayBreak(params: AQH_EVE_79) {
    return this.endpointService.aqh_eve_79(params).pipe(map((data => {
      return data.data;
    })));
  }

  deleteDayBreak(day_break_id: number) {
    return this.endpointService.aqh_eve_80(day_break_id).pipe(map((data => {
      return data;
    })));
  }

  // Event Expenses
  getEventExpenses(event_id: number) {
    let payload: AQH_EVE_93 = { event_id };
    return this.endpointService.aqh_eve_93(payload).pipe(map((data => {
      return data.data;
    })));
  }

  createEventExpense(params: _AQH_EVE_90) {
    let payload: AQH_EVE_90 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    };
    return this.endpointService.aqh_eve_90(payload).pipe(map((data => {
      return data.data;
    })));
  }

  updateEventExpense(params: _AQH_EVE_91) {
    let payload: AQH_EVE_91 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    };
    return this.endpointService.aqh_eve_91(payload).pipe(map((data => {
      return data.data;
    })));
  }

  deleteEventExpense(expense_id: number) {
    let payload: AQH_EVE_92 = {
      company_id: this.storageService.getSelectedCompanyId(),
      expense_id
    };
    return this.endpointService.aqh_eve_92(payload).pipe(map((data => {
      return data;
    })));
  }

  uploadExpenseImage(expense_id: number, image: File, position: number) {
    let payload: AQH_EVE_94 = {
      company_id: this.storageService.getSelectedCompanyId(),
      expense_id,
      image,
      position
    };
    return this.endpointService.aqh_eve_94(payload).pipe(map((data => {
      return data.data;
    })));
  }

  // ==================== MEMBERSHIP PRICING ====================

  // Get membership prices for a class
  getClassMembershipPrices(event_class_id: number) {
    let payload: AQH_EVE_100 = { event_class_id };
    return this.endpointService.aqh_eve_100(payload).pipe(map((data => {
      return data.data;
    })));
  }

  // Set membership prices for a class (batch)
  setClassMembershipPrices(event_class_id: number, prices: Array<{plan_id: number; price: number}>) {
    let payload: AQH_EVE_101 = {
      company_id: this.storageService.getSelectedCompanyId(),
      event_class_id,
      prices
    };
    return this.endpointService.aqh_eve_101(payload).pipe(map((data => {
      return data.data;
    })));
  }

  // Delete membership price for a class
  deleteClassMembershipPrice(price_id: number) {
    let payload: AQH_EVE_102 = {
      company_id: this.storageService.getSelectedCompanyId(),
      price_id
    };
    return this.endpointService.aqh_eve_102(payload).pipe(map((data => {
      return data;
    })));
  }

  // Get membership prices for a package
  getPackageMembershipPrices(package_id: number) {
    let payload: AQH_EVE_103 = { package_id };
    return this.endpointService.aqh_eve_103(payload).pipe(map((data => {
      return data.data;
    })));
  }

  // Set membership prices for a package (batch)
  setPackageMembershipPrices(package_id: number, prices: Array<{plan_id: number; price_cents: number}>) {
    let payload: AQH_EVE_104 = {
      company_id: this.storageService.getSelectedCompanyId(),
      package_id,
      prices
    };
    return this.endpointService.aqh_eve_104(payload).pipe(map((data => {
      return data.data;
    })));
  }

  // Delete membership price for a package
  deletePackageMembershipPrice(price_id: number) {
    let payload: AQH_EVE_105 = {
      company_id: this.storageService.getSelectedCompanyId(),
      price_id
    };
    return this.endpointService.aqh_eve_105(payload).pipe(map((data => {
      return data;
    })));
  }

  // Get membership prices for a service
  getServiceMembershipPrices(event_service_id: number) {
    let payload: AQH_EVE_106 = { event_service_id };
    return this.endpointService.aqh_eve_106(payload).pipe(map((data => {
      return data.data;
    })));
  }

  // Set membership prices for a service (batch)
  setServiceMembershipPrices(event_service_id: number, prices: Array<{plan_id: number; price: number}>) {
    let payload: AQH_EVE_107 = {
      company_id: this.storageService.getSelectedCompanyId(),
      event_service_id,
      prices
    };
    return this.endpointService.aqh_eve_107(payload).pipe(map((data => {
      return data.data;
    })));
  }

  // Delete membership price for a service
  deleteServiceMembershipPrice(price_id: number) {
    let payload: AQH_EVE_108 = {
      company_id: this.storageService.getSelectedCompanyId(),
      price_id
    };
    return this.endpointService.aqh_eve_108(payload).pipe(map((data => {
      return data;
    })));
  }

  // Get user prices for an event (with resolved membership discounts)
  getUserEventPrices(params: Omit<AQH_EVE_109, 'user_id'> & { user_id?: string }) {
    let payload: AQH_EVE_109 = { ...params };
    return this.endpointService.aqh_eve_109(payload).pipe(map((data => {
      return data.data;
    })));
  }

  // ==================== EVENT CO-ORGANISERS ====================
  // Note: These endpoints require backend implementation. Error toasts disabled until ready.

  // Get co-organisers for an event
  getEventCoOrganisers(params: _AQH_EVE_110) {
    let payload: AQH_EVE_110 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    };
    return this.endpointService.aqh_eve_110(payload, false).pipe(map((data => {
      return data.data;
    })));
  }

  // Add co-organiser to event
  addEventCoOrganiser(params: _AQH_EVE_111) {
    let payload: AQH_EVE_111 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    };
    return this.endpointService.aqh_eve_111(payload, false).pipe(map((data => {
      return data.data;
    })));
  }

  // Update co-organiser access level
  updateEventCoOrganiser(params: _AQH_EVE_112) {
    let payload: AQH_EVE_112 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    };
    return this.endpointService.aqh_eve_112(payload, false).pipe(map((data => {
      return data.data;
    })));
  }

  // Remove co-organiser from event
  removeEventCoOrganiser(params: _AQH_EVE_113) {
    let payload: AQH_EVE_113 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    };
    return this.endpointService.aqh_eve_113(payload, false).pipe(map((data => {
      return data;
    })));
  }

  // Get events where company is a co-organiser
  getCoOrganisedEvents() {
    let payload: AQH_EVE_114 = {
      company_id: this.storageService.getSelectedCompanyId(),
    };
    return this.endpointService.aqh_eve_114(payload, false).pipe(map((data => {
      return data.data;
    })));
  }

  // Search companies for co-organiser selection
  // Fetches all public companies and filters client-side
  searchCompaniesForCoOrganiser(search_string: string, event_id?: number) {
    const currentCompanyId = this.storageService.getSelectedCompanyId();
    const searchLower = search_string.toLowerCase();
    return this.endpointService.cor_coy_10({}).pipe(map((data => {
      // Filter out the current company and match search string
      return data.data.filter(company =>
        company.company_id !== currentCompanyId &&
        company.company_name?.toLowerCase().includes(searchLower)
      );
    })));
  }

  // ==================== EVENT CANCELLATION ====================

  // Cancel event and process refunds
  cancelEvent(event_id: number) {
    let payload: AQH_EVE_160 = {
      company_id: this.storageService.getSelectedCompanyId(),
      event_id
    };
    return this.endpointService.aqh_eve_160(event_id, payload).pipe(map((data => {
      return data.data;
    })));
  }

  // Get manual refund requirements for cancelled event
  getManualRefunds(event_id: number) {
    let payload: AQH_EVE_161 = {
      company_id: this.storageService.getSelectedCompanyId(),
      event_id
    };
    return this.endpointService.aqh_eve_161(event_id, payload).pipe(map((data => {
      return data.data;
    })));
  }

  // Mark manual refund as completed
  completeManualRefund(requirement_id: number, notes?: string) {
    let payload: AQH_EVE_162 = {
      company_id: this.storageService.getSelectedCompanyId(),
      requirement_id,
      notes
    };
    return this.endpointService.aqh_eve_162(requirement_id, payload).pipe(map((data => {
      return data.data;
    })));
  }

  // ==================== EVENT TASKS ====================

  getEventTasks(params: { event_id: number }) {
    let payload: AQH_EVE_170 = {
      company_id: this.storageService.getSelectedCompanyId(),
      event_id: params.event_id
    };
    return this.endpointService.aqh_eve_170(payload).pipe(map(data => data.data));
  }

  createEventTask(params: _AQH_EVE_171) {
    let payload: AQH_EVE_171 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    };
    return this.endpointService.aqh_eve_171(payload).pipe(map(data => data.data));
  }

  updateEventTask(params: _AQH_EVE_172) {
    let payload: AQH_EVE_172 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    };
    return this.endpointService.aqh_eve_172(payload).pipe(map(data => data.data));
  }

  deleteEventTask(params: _AQH_EVE_173) {
    let payload: AQH_EVE_173 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    };
    return this.endpointService.aqh_eve_173(payload).pipe(map(data => data));
  }

  toggleEventTask(params: _AQH_EVE_174) {
    let payload: AQH_EVE_174 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    };
    return this.endpointService.aqh_eve_174(payload).pipe(map(data => data.data));
  }

  // ==================== EVENT MEMBERS ====================

  getEventMembers(params: AQH_EVE_180) {
    return this.endpointService.aqh_eve_180(params).pipe(map(data => data.data));
  }

  addEventMember(params: AQH_EVE_181) {
    return this.endpointService.aqh_eve_181(params).pipe(map(data => data.data));
  }

  updateEventMember(params: AQH_EVE_182) {
    return this.endpointService.aqh_eve_182(params).pipe(map(data => data.data));
  }

  removeEventMember(params: AQH_EVE_183) {
    return this.endpointService.aqh_eve_183(params).pipe(map(data => data));
  }

  getMyMemberEvents() {
    return this.endpointService.aqh_eve_184().pipe(map(data => data.data));
  }

  getEventAccess(params: AQH_EVE_185) {
    return this.endpointService.aqh_eve_185(params).pipe(map(data => data.data));
  }
}
